module.exports = __webpack_public_path__ + "img/team-06.aa762547.jpg";